module.exports = __webpack_public_path__ + "static/fonts/iconfont.a62dd5c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font/iconfont.woff?t=1741155911033
// module id = GM3w
// module chunks = 141